@if (vm$ | async; as vm) {
  @if (vm.form) {
    <ng-container [formGroup]="vm.form">
      @if (vm.label) {
        <label class="likert__label" [attr.data-qa]="vm.key">
          {{ vm.label }}
          @if (vm.required) {
            <span> *</span>
          }
        </label>
      }
      <div class="likert__scale-wrap">
        <jui-likert
          size="md"
          [dataqastring]="vm.key"
          [value]="vm.form.get(vm.key)?.value"
          [minvalue]="vm.minValue"
          [maxvalue]="vm.maxValue"
          [readonly]="vm.readonly"
          (valueChange)="selectionChanged($event.detail)">
          <span slot="bottom-hint">{{ vm.bottomHint }}</span>
          <span slot="top-hint">{{ vm.topHint }}</span>
        </jui-likert>
      </div>
    </ng-container>
  }
}
